<template>
  <canvas ref="radarCanvas" :width="size" :height="size"></canvas>
</template>

<script setup>
import {ref, onMounted, watch} from 'vue'
import {
  Chart,
  RadarController,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
} from 'chart.js'

Chart.register(
    RadarController,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
)
// eslint-disable-next-line no-undef
const props = defineProps({
  data: {
    type: Array,
    required: true,
    validator: arr =>
        Array.isArray(arr) &&
        arr.every(e => typeof e.titre === 'string' && typeof e.valeur === 'number')
  },
  size: {
    type: Number,
    default: 300 // taille du canvas en pixels
  }
})

const radarCanvas = ref(null)
let radarChartInstance = null

const createChart = () => {
  if (!radarCanvas.value) return
  if (radarChartInstance) radarChartInstance.destroy()

  radarChartInstance = new Chart(radarCanvas.value, {
    type: 'radar',
    data: {
      labels: props.data.map(d => d.titre),
      datasets: [{
        label: 'Niveau',
        data: props.data.map(d => d.valeur),
        fill: true,
        borderColor: '#007BFF',
        backgroundColor: 'rgba(0, 123, 255, 0.2)',
        pointBackgroundColor: '#007BFF',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: '#007BFF'
      }]
    },
    options: {
      scales: {
        r: {
          suggestedMin: 0,
          suggestedMax: 100,
          ticks: {
            stepSize: 20,
            backdropColor: 'transparent',
            color: '#00f0ff',
            font: {
              size: 12
            }
          },
          pointLabels: {
            color: '#00f0ff',
            font: {
              size: 14
            },
            padding: 10
          },
          grid: {
            color: 'rgba(255,255,255,0.5)'
          },
          angleLines: {
            color: 'rgba(255,255,255,0.5)'
          }
        }
      },
      plugins: {
        legend: {
          display: false
        }
      },
      responsive: false, // car on contrôle width/height manuellement
      maintainAspectRatio: false
    }
  })
}

onMounted(createChart)
watch(() => props.data, createChart, {deep: true})
</script>

<style scoped>
canvas {
  display: block;
  margin: auto;
}
</style>
